class Member {
	static GUARDIAN = 1;
	static ADMIN = 2;
	static LIMITED = 3;

	static PENDING = 1;
	static INVITED = 2;
	static ACTIVE = 3;
	static LEFT = 4;
	static REJECTED = 5;
	static BLOCKED = 6;

	static fromArray(data, list) {
		let inst = new Member(list);
		inst._id = data.member_id;
		inst._groupId = data.group_id;
		inst._name = data.first_name + ' ' + data.last_name;
		inst._status = data.member_status;
		inst.own = data.own;
		inst.inherited = data.inherited;
		inst._fromNames = data.from_names;
		inst.permissions = new MemberPermission(inst, data.member_permission);

		inst.buildElem();
		return inst;
	}

	constructor(list) {
		this._list = list;

		this._id = 0;
		this._groupId = null;
		this._name = null;
		this._allocation = null;
		this._typeName = '';
		this._selectable = true;
		this._fromNames = '';

		this._popup = null;
		this.permissions = null;
	}

	get statusLabel() {
		switch (this._status) {
			case Member.INVITED: return UI.span('ps-2 text-sm', '(' + _('Invite Pending') + ')');
			case Member.PENDING: return UI.span('ps-2 text-sm', '(' + _('Request Pending') + ')');
			default: return null;
		}
	}
	
	buildElem() {
		if (nav.entityType == Nav.COMMUNITY) {
			this.allocationButton = UI.priIconBtn('licences', 18, {
				'click': this.setAllocation.bind(this)
			}, {
				'data-tip': _("Click to allocate / de-allocate licence")
			});
			this.allocationButton.style.color = this.allocation ? 'var(--color-highlight)' : 'var(--text-faint)';
		}
		else this.allocationButton = null;

		this.permissionsBtn = UI.priIconBtn('key', 18, {
			'click': () => this.popup.handle(this.permissionsBtn)
		});
		
		this.permissionsBtn.disabled = this.inherited;

		this._elem = UI.listRow([
			UI.styleChk(this._chkBox = UI.chk(
				null,
				{'click': () => this._list.selection.toggle(this)}
			)),
			this._elemText = UI.div('flex-1 pe-2'),
			UI.div('flex-0', [
				(
					(nav.unit?.isAdmin && !nav.unit.own) || 
					(nav.unit?.isAdmin && nav.unit.guardians == 0) 
				) &&
				!(this.own && nav.unit.guardians == 0)
					? this.permissionsBtn : null,
				nav.unit?.isAdmin ? this.teamButton = UI.priIconBtn('users-team', 22, {
					'click': this.showTeamChecklist.bind(this)
				}, {
					'data-tip': _("Teams this member belongs to")
				}) : null,
				nav.unit?.isAdmin ? this.allocationButton : null,
				nav.unit?.isAdmin ? this.moreBtn = UI.priIconBtn('ellipsis-v', 18, {
					'click': () => {
						this._list.showMoreMenu(this);
					}
				}) : null
			],
			{
				'click': () => {this._selectable = false;}
			})
		],
		{
			'click': () => {
				if (this._selectable) this._list.selection.toggle(this);
				this._selectable = true;
			}
		});
		
		this.update();
	}

	get id() {return this._id;}

	get type() {
		return this.permissions.type;
	}

	get isGuardian() {
		return this.permissions.can(MemberPermission.GUARDIAN);
	}

	get isAdmin() {
		return this.permissions.can(MemberPermission.ADMIN);
	}

	get popup() {
		if (this._popup == null) {
			this._popup = Dialog.Popup(
				UI.div('p-3', this.permissions.elem)
			).sticky();
		}
		return this._popup;
	}

	get allocation() {
		return this._allocation != null && 0 < this._allocation;
	}

	set allocation(value) {
		this._allocation = value;
		this.allocationButton.style.color = value ? 'var(--color-highlight)' : 'var(--text-faint)';
	}

	get elem() {return this._elem;}

	get checked() {return this._chkBox.checked;}
	set checked(v) {this._chkBox.checked = !!v;}

	update() {
		if (!this._elem) return;
		this._elemText.innerHTML = this._name;
		if (this.statusLabel) this._elemText.appendChild(this.statusLabel);
		if (this.inherited) {
			this._elemText.appendChild(UI.span('ms-2', UI.icon('inherited', 22)));
			this._elemText.appendChild(UI.span('ms-2 text-sm', 'Inherited from ' + this._fromNames));
		}

		this.permissionsBtn.replaceChild(
			this.permissions.buttonIcon,
			this.permissionsBtn.firstChild
		);
	}
	
	showTeamChecklist(ev) {
		this._list.teams.members(this._id, this.teamButton);
	}

	setAllocation(event) {
		if (this.allocation) {
			Dialog.Confirm(
				_("Confirm REMOVE licence allocation!"),
				_("REMOVE LICENCE"),
				() => {
					API.delete(
						'allocations',
						{
							userId: this.id
						}
					)
					.then(reply => {
						if(showError(reply)) return;
						this.allocation = 0;
					});
				}
			);
		} else {
			Dialog.Confirm(
				_("Confirm ALLOCATE licence to member"),
				_("ALLOCATE LICENCE"),
				() => {
					API.insert(
						'allocations',
						{
							userId: this.id
						}
					)
					.then(reply => {
						if (showError(reply)) return;
						this.allocation = 1;
					});
					ajg('allocation/give', [
						'id=' + this.id
					], null, (reply) => {
						if (showError(reply)) return;
						this.allocation = 1;
					})
				}
			);
		}
		stopEv(event);
	}
}